<p>register.component works!</p>
